<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <select
        v-model="inputValue"
        id="form-pass-cause"
        class="form-control"
        :disabled="disabled"
        @input="emit"
        @change="emit"
        @blur="emit"
    >
      <option v-for="purpose in items" v-bind:key="purpose.id" :value="purpose.id">{{ purpose.name }}</option>
    </select>

    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'PassKindInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Тип пропуска'
    },

    inputName: {
      default: 'pass_kind_id'
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    if (this.isNew) {
      this.inputValue = this.items[0]?.id
    }
  },

  watch: {
    items (items) {
      if (items.length === 1) {
        this.inputValue = items[0]?.id
      }
    }
  }
}
</script>
